import { render, staticRenderFns } from "./DomainsTable.vue?vue&type=template&id=bbb96fa4"
import script from "./DomainsTable.vue?vue&type=script&lang=js"
export * from "./DomainsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports